import { GetStaticProps, NextPage } from "next";
import Head from "next/head";

import Media from "@/sections/Media";

import { fetchAboutPageData, fetchNews } from "@/api/ssg-api";
import { LandingEntity, LandingNewsEntity } from "@/domain";
import { FirstSection, SecondSection, ThirdSection } from "src/landing/about-us";
import { kuberHeadTitle } from "@/data/constants";

interface Props {
  news: LandingNewsEntity[];
  about: LandingEntity[];
}

const AboutPage: NextPage<Props> = ({ news, about }) => {
  return (
    <>
      <Head>
        <title>О компании | {kuberHeadTitle}</title>
      </Head>

      <FirstSection info={about[0]} />

      <SecondSection info={about[1]} />

      <ThirdSection info={about[2]} />

      {/* Новости на главной */}

      <Media news={news} />
    </>
  );
};

export default AboutPage;

export const getStaticProps: GetStaticProps<Props> = async (context) => {
  const responses = await Promise.all([fetchNews({ limit: 3, offset: 0 }), fetchAboutPageData()]);

  const newsResponse = responses[0];
  const aboutPageDataResponse = responses[1];

  return {
    props: {
      news: newsResponse.items,
      about: aboutPageDataResponse,
    },
  };
};
